module.exports = __webpack_public_path__ + "img/fly-en.cb67de0e.svg";